import React, { FC, } from 'react'
import styled, { DefaultTheme } from 'styled-components'
import { Wei } from '../../../utils/types'
import { priceFormatter } from '../../../logic/financials/precise'
import { coinImage } from '../../../assets/coins/coins'
import CurrencyLogo, {LargeCurrencyLogo} from '../../CurrencyLogo'
import { fromWei } from '../../../utils/static-web3'
import { Pool } from '../../../logic/pools/Pool'
import { Token } from '../../../logic/token/token'
import {
  PVSwapLine,
  PVSwapQuantity,
  PVTokenSymbol,
  PVProductionPanel,
  PVProductionLine,
  PVProductionInformation,
} from '../../swap/preswap/PreSwapPopup'
import { SectionTitle } from '../../swap/preswap/PostSwapPopup'
import { ArrowDownFixed } from '../../catalog/ArrowDownFixed'
import { protocolPrecision } from '../../../config'
import { SmallCurrencyLogo } from '../../CurrencyLogo'
// @ts-ignore no type-package yet for react-arrows
import Arrow, { DIRECTION } from 'react-arrows'
import { useDarkMode } from '../../useDarkMode'


const MultiDepositPreviewWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: auto;
`


export interface Props {
  amounts: Map<Token, Wei>
  // TODO: difference with amounts ?
  expectedShareTokensEquivalent?: Map<Token, Wei | undefined>
  expectedShareTokensViaAggregator?: Map<Token, Wei | undefined>
  pool: Pool
  expectedShare?: Wei
  minimumShare?: Wei
  expectedShareSlippage?: number
  tokensSlippage?: number
  isWithdraw?: boolean
}

export const MultiDepositPreview: FC<Props> = ({
  amounts,
  expectedShareTokensEquivalent,
  expectedShareTokensViaAggregator,
  pool,
  expectedShare,
  minimumShare,
  expectedShareSlippage,
  tokensSlippage,
  isWithdraw,
}) => {
  const shareIsAnEstimate =
    expectedShareSlippage !== undefined && expectedShareSlippage > 0
  const _isWithdraw = isWithdraw != undefined && isWithdraw
  const inputsAreEstimates =
    tokensSlippage !== undefined && tokensSlippage > 0 && !_isWithdraw
    const [theme, themeToggler, _] = useDarkMode()
    
  const isBindedTokenVia0x = expectedShareTokensViaAggregator != null && amounts.size === Array.from(amounts.keys()).reduce((acc, token) => acc + (expectedShareTokensViaAggregator.has(token)?1:0), 0)
  
  return (
    <MultiDepositPreviewWrapper>
      {_isWithdraw ? (
        <>
          <SectionTitle>Exact input:</SectionTitle>
          <div style={{ alignSelf: 'center', minWidth: '100%' }}>
            <PVSwapLine>
              <div className={'align-center'}>
                <PVTokenSymbol>Pool shares</PVTokenSymbol>
              </div>
              <PVSwapQuantity>
                {priceFormatter(fromWei(expectedShare!, protocolPrecision))}
              </PVSwapQuantity>
            </PVSwapLine>
          </div>

          <ArrowDownFixed />

          <SectionTitle>Expected output:</SectionTitle>
          <div style={{ alignSelf: 'center', minWidth: '100%' }}>
            {pool.tokens.map((token, idx) => (
              <PVSwapLine key={token.symbol} className={idx > 0 ? 'pt5' : ''}>
                <div className={'align-center'}>
                  <CurrencyLogo src={coinImage(token.symbol)!} />
                  <PVTokenSymbol>{token.symbol}</PVTokenSymbol>
                </div>
                <PVSwapQuantity>
                  {priceFormatter(fromWei(amounts.get(token)!, token.decimals))}
                </PVSwapQuantity>
              </PVSwapLine>
            ))}
          </div>
        </>
      ) : (
        <div style={{display:'flex',flexDirection:'column',width:'100%',alignSelf:'center',justifyContent:'center'}}>

          {
          expectedShareTokensViaAggregator ? (
            
            <div style={{display:'flex',flexDirection:'column',width:'100%',alignSelf:'center',justifyContent:'center'}}>
            
              <ViaAggregatorInput>
              <SectionTitleInput>Exact input:</SectionTitleInput>
              <div style={{display:'flex',flexDirection:'column',alignSelf:'center',justifyContent:'center'}}>
                {Array.from(amounts.keys()).map((token, idx) => (
                  <LineWrapperMedium key={token.symbol} className={idx > 0 ? 'pt5' : ''}>
                    <TokenWrapperInput className={'align-center'}>
                      <LargeCurrencyLogo src={coinImage(token.symbol)!} />
                      <PVTokenSymbolLarge>{token.symbol}</PVTokenSymbolLarge>
                    </TokenWrapperInput>
                    <PVSwapQuantityInput>
                      {priceFormatter(fromWei(amounts.get(token)!, token.decimals))}
                    </PVSwapQuantityInput>
                  </LineWrapperMedium>
                ))}
                </div>

              </ViaAggregatorInput>

            <div style={{ display: 'flex', alignSelf:'center',justifyContent:'center',marginBottom:'3rem' }}>
                {isBindedTokenVia0x && <div id='dynamicArrowLeftTop' style={{width:'50px'}}></div>}
              <div id='dynamicArrowRightTop' style={{width:'50px'}}></div>
            </div>

            {
              isBindedTokenVia0x
              && <Arrow
                className='dynamicArrow'
                from={{
                  direction: DIRECTION.BOTTOM,
                  node: () => document.getElementById('dynamicArrowLeftTop'),
                  translation: [0, 0.35],
                }}
                to={{
                  direction: DIRECTION.TOP,
                  node: () => document.getElementById('dynamicArrowLeft'),
                  translation: [0, -0.5],
                }}
              />
            }

            <Arrow
              className='dynamicArrow'
              from={{
                direction: DIRECTION.BOTTOM,
                node: () => document.getElementById('dynamicArrowRightTop'),
                translation: [0, isBindedTokenVia0x ? 0.35 : 0],
              }}
              to={{
                direction: DIRECTION.TOP,
                node: () => document.getElementById('aggregatorImage'),
                translation: [0, isBindedTokenVia0x ? -0.15 : 0],
              }}
            />
  
            <ViaAggregatorSectionWrapper onlyOneElement={!isBindedTokenVia0x}>
            
              {
                isBindedTokenVia0x 
                && <div style={{display:'flex', flexDirection:'column',paddingTop:'1rem' }} id='dynamicArrowLeft'>
                  {Array.from(amounts.keys()).map((token, idx) => (
                    <LineWrapperWithoutAggregator key={token.symbol} className={idx > 0 ? 'pt5' : ''}>
                      <TokenWrapperWithoutAggregator className={'align-center'}>
                        <SmallCurrencyLogo src={coinImage(token.symbol)!} />
                        <PVTokenSymbolViaAggregator>{token.symbol}</PVTokenSymbolViaAggregator>
                      </TokenWrapperWithoutAggregator>
                      <PVSwapQuantityWithoutAggregator>
                        {priceFormatter(fromWei(expectedShareTokensViaAggregator.get(token)!, token.decimals))}
                      </PVSwapQuantityWithoutAggregator>
                    </LineWrapperWithoutAggregator>
                  ))}
                </div>
              }

              <div id='dynamicArrowRight' style={{minWidth:'220px'}}>
                
                <ViaAggregatorImage id='aggregatorImage'>
                  <div  style={{display:'flex',flexDirection:'column',padding:'1rem 1.5rem 1rem 1.5rem',borderRadius:'20px',alignItems:'center',justifyContent:'center'}}>
                    <AggregatorLogo theme={theme} />
                  </div>
                </ViaAggregatorImage>

                <Arrow
                  className='dynamicArrow'
                  from={{
                    direction: DIRECTION.BOTTOM,
                    node: () => document.getElementById('aggregatorImage'),
                    translation: [0, 0.35],
                  }}
                  to={{
                    direction: DIRECTION.TOP,
                    node: () => document.getElementById('viaAggregatorSection'),
                    translation: [0, -0.25],
                  }}
                />

                <ViaAggregatorSection id ="viaAggregatorSection">
                  
                  <div style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',alignSelf:'center',width:'100%'}}>
                  

                    <div style={{ alignSelf: 'center', width: '100%' }}>
                    <SectionTitleViaAggregator>Intermediary swaps:</SectionTitleViaAggregator>
                      {Array.from(Array.from(expectedShareTokensViaAggregator.keys())
                          .reduce((acc, t) => {
                              if (!amounts.has(t))
                                acc.set(t, expectedShareTokensViaAggregator.get(t))
                              return acc;
                            }, 
                            new Map<Token, Wei | undefined>()
                          )!.keys()).map((token, idx) => (
                        <LineWrapper key={token.symbol} className={idx > 0 ? 'pt5' : ''}>
                          <TokenWrapper className={'align-center'}>
                            <SmallCurrencyLogo src={coinImage(token.symbol)!} />
                            <PVTokenSymbolViaAggregator>{token.symbol}</PVTokenSymbolViaAggregator>
                          </TokenWrapper>
                          <PVSwapQuantityViaAggregator>
                            {priceFormatter(fromWei(expectedShareTokensViaAggregator!.get(token)!, token.decimals))}
                          </PVSwapQuantityViaAggregator>
                        </LineWrapper>
                      ))}
                    </div>

                  </div>
                </ViaAggregatorSection>
              </div>
            </ViaAggregatorSectionWrapper>
            <div style={{marginTop:'2.5rem'}}/>

          </div>
          ): (
          <div style={{width:'100%'}}>
          <SectionTitle>
            {inputsAreEstimates ? 'Expected' : 'Exact'} input:
          </SectionTitle>
          <div style={{ alignSelf: 'center', minWidth: '100%' }}>
            {Array.from(amounts.keys()).map((token, idx) => (
              <PVSwapLine key={token.symbol} className={idx > 0 ? 'pt10' : ''}>
                <div className={'align-center'}>
                  <CurrencyLogo src={coinImage(token.symbol)!} />
                  <PVTokenSymbol>{token.symbol}</PVTokenSymbol>
                </div>
                <PVSwapQuantity>
                  {priceFormatter(fromWei(amounts.get(token)!, token.decimals))}
                </PVSwapQuantity>
              </PVSwapLine>
            ))}
          </div>
          </div>
        )}

          <ArrowDownFixed />

          <SectionTitle>
            {shareIsAnEstimate ? 'Expected' : 'Exact'} output:
          </SectionTitle>
          <div style={{ alignSelf: 'center', minWidth: '100%' }}>
            <PVSwapLine>
              <div className={'align-center'}>
                <PVTokenSymbol>Pool shares</PVTokenSymbol>
              </div>
              <PVSwapQuantity>
                {priceFormatter(fromWei(expectedShare!, protocolPrecision))}
              </PVSwapQuantity>
            </PVSwapLine>
          </div>
          {expectedShareTokensEquivalent && (
            <TokenEquivalenceSection className="mt5">
              <EquivalenceTitle>Corresponding value in token</EquivalenceTitle>
              <div style={{ alignSelf: 'center', width: '100%' }}>
                {pool.tokens.map((token, idx) => (
                  <PVSwapLine
                    key={token.symbol}
                    className={idx > 0 ? 'pt5' : ''}
                  >
                    <div className={'align-center'}>
                      <CurrencyLogo src={coinImage(token.symbol)!} />
                      <PVTokenSymbol>{token.symbol}</PVTokenSymbol>
                    </div>
                    <PVSwapQuantity>
                      {priceFormatter(
                        fromWei(
                          expectedShareTokensEquivalent.get(token)!,
                          token.decimals
                        )
                      )}
                    </PVSwapQuantity>
                  </PVSwapLine>
                ))}
              </div>
            </TokenEquivalenceSection>
          )}
        </div>
      )}
      {shareIsAnEstimate && (
        <div style={{ alignSelf: 'center', minWidth: '100%' }}>
          {
          expectedShareTokensViaAggregator ? (
          <div style={{ alignSelf: 'center', minWidth: '100%' }}>
            <PVProductionInformation>
              <div style={{ textAlign: 'left', flex:'display', justifyContent:'center',alignItems:'center' }}>
              We take care to convert your input asset at the best rate using <span className={'numeric'}>0x Protocol</span>, without any additional cost.
              </div>
              <div className={'pt5'} style={{ textAlign: 'left', flex:'display', justifyContent:'center',alignItems:'center'}}>
              Those swaps will experience less than <span className={'numeric'}>{expectedShareSlippage * 100}%</span> slippage or the transaction will be cancelled.
              </div>
            </PVProductionInformation>
          </div>
            
          ):(
          <div style={{ alignSelf: 'center', minWidth: '100%' }}>
            <PVProductionPanel className={'pt20 light'}>
              <PVProductionLine main={true} className={'justify-between'}>
                <div>Expected output</div>
                <div className={'numeric'}>
                  {priceFormatter(fromWei(expectedShare!, protocolPrecision))}{' '}
                  Pool shares
                </div>
              </PVProductionLine>
              <PVProductionLine main={false} className={'justify-between'}>
                <div className={'pr20'}>
                  Minimum output <br />
                  <span className={'small-text'} style={{ opacity: '0.7' }}>
                    (Slippage tolerance :{' '}
                    <span className={'numeric'}>
                      {expectedShareSlippage * 100}%
                    </span>
                    )
                  </span>
                </div>
                <div className={'numeric'} style={{ alignSelf: 'start' }}>
                  {priceFormatter(fromWei(minimumShare!, protocolPrecision))} Pool
                  shares
                </div>
              </PVProductionLine>
            </PVProductionPanel>
            <PVProductionInformation>
              <div style={{ textAlign: 'left' }}>
                You will receive at least{' '}
                <span className={'numeric'}>
                  {priceFormatter(fromWei(minimumShare!, protocolPrecision))}
                </span>{' '}
                Pool shares or the transaction will be cancelled.
              </div>
            </PVProductionInformation>
          </div>
        )}
        </div>
      )}

      {inputsAreEstimates && (
        <div style={{ alignSelf: 'center', minWidth: '100%' }}>
          <PVProductionInformation>
            <div style={{ textAlign: 'left' }}>
              You will receive{' '}
              <span className={'numeric'}>
                {priceFormatter(fromWei(expectedShare!, protocolPrecision))}
              </span>{' '}
              Pool shares.
            </div>
            <div style={{ textAlign: 'left' }}>
              Final input amount{amounts.size > 1 ? 's' : ''} will be at max{' '}
              <span className={'numeric'}>+{tokensSlippage * 100}%</span> above
              the estimates or the transaction will be cancelled.
            </div>
          </PVProductionInformation>
        </div>
      )}

      {_isWithdraw && tokensSlippage && tokensSlippage > 0 && (
        <PVProductionInformation>
          <div style={{ textAlign: 'left' }}>
            Received amount{amounts.size > 1 ? 's' : ''} will be at min{' '}
            <span className={'numeric'}>+{tokensSlippage * 100}%</span> under
            the estimates or the transaction will be cancelled.
          </div>
        </PVProductionInformation>
      )}
    </MultiDepositPreviewWrapper>
  )
}

const EquivalenceTitle = styled.div`
  font-family: Montserrat-Light;
  text-align: center;
  width: 100%;
  padding-bottom: 0.75rem;
  font-size: 1.25rem;
`

const TokenEquivalenceSection = styled.div`
  width: 100%;
  background-color: ${({ theme }) =>
    theme.tokenEquivalenceSectionBackgroundColor};
  border-radius: 3.15rem;
  padding: 0.75rem 2rem 1rem 2rem;
  display: flex;
  flex-direction: column;
`

interface ViaAggregatorSectionWrapperProps {
  onlyOneElement: boolean
}
const ViaAggregatorSectionWrapper = styled.div<ViaAggregatorSectionWrapperProps>`
  width: 85%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${(p) => p.onlyOneElement ? 'center' : 'space-between'};
  align-self:center;
`

const ViaAggregatorSection = styled.div`
  color: ${({ theme }) => theme.viaAggregatorSectionColor};
  background-color: ${({ theme }) => theme.viaAggregatorSectionBackgroundColor};
  border-radius: 3.15rem;
  padding: 1.5rem 2rem 1.5rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const ViaAggregatorImage = styled.div`
  color: ${({ theme }) => theme.viaAggregatorColor};
  background-color: ${({ theme }) => theme.viaAggregatorBackgroundColor};
  font-size: 0.9rem;
  align-self: center;
  align-items: center;
  justify-content: center;
  font-family: Montserrat-Light;
  margin:1rem 0 1rem 0;
  border-radius:30px;
`

const ViaAggregatorInput = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 50px;
  color: ${({ theme }) => theme.viaAggregatorInputColor};
  font-size: 1.5rem;
  align-self: center;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  padding: 0rem 0rem 0.25rem 0rem;
`

const LineWrapperWithoutAggregator = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  align-self: center;
`

const LineWrapper = styled.div`
  min-width: 150px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 2rem;
  align-items: center;
  align-self: center;
`

const LineWrapperMedium = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 2rem;
  align-items: center;
  align-self: center;
`

const TokenWrapperInput = styled.div`
  width:100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-size: 2rem;
  align-items: center;
`

const TokenWrapper = styled.div`
  width:100%;
  display: flex;
  flex-direction: row;
  justify-content: start;
  font-size: 2rem;
  align-items: center;
`

const TokenWrapperWithoutAggregator = styled.div`
  width:100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-size: 2rem;
  align-items: center;
`

export const PVTokenSymbolViaAggregator = styled.span`
  text-align: left;
  font-size: 1.25rem;
  font-family: Montserrat-Light;
`

export const PVSwapQuantityViaAggregator = styled.span`
  white-space: nowrap;
  text-align: left;
  font-family: Montserrat-Medium, Montserrat;
  font-size: 1.75rem;
`

export const PVSwapQuantityWithoutAggregator = PVSwapQuantityViaAggregator

export const PVSwapQuantityInput = styled.span`
  text-align: left;
  font-family: Montserrat-Medium, Montserrat;
  font-size: 3rem;
`

export const SectionTitleInput = styled.div`
  font-family: Montserrat-Light;
  text-align: right;
  padding-bottom: 1rem;
  font-size: 1.25rem;
`

export const SectionTitleViaAggregator = styled.div`
  font-family: Montserrat-Light;
  text-align: right;
  padding-bottom: 0.5rem;
  font-size: 1rem;
`

const PVTokenSymbolLarge = styled.div`
  text-align: left;
  font-size: 2.5rem;
  font-family: Montserrat-Light;
`

interface AggregatorImgProps {
  theme: DefaultTheme
}

function AggregatorLogo({ theme }: AggregatorImgProps) {
  return (
    <img src={theme.aggregatorLogo} width={theme.aggregatorLogoSize}/>
  )
}